import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PinCustomValidators {

  // Custom validator to check if pin and confirm pin match
  static MatchValidator(pinControls: string[], confirmPinControls: string[]): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      let isMatch = true;
      
      // Loop through all pin controls and check if they match the corresponding confirm pin controls
      for (let i = 0; i < pinControls.length; i++) {
        const pinControl = formGroup.get(pinControls[i]);
        const confirmPinControl = formGroup.get(confirmPinControls[i]);
        
        if (pinControl?.value !== confirmPinControl?.value) {
          isMatch = false;
          break;
        }
      }

      return isMatch ? null : { mismatch: true };
    };
  }

  // Custom validator to check the length of the pin (all 6 digits)
  static PinLengthValidator(pinControls: string[]): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const pinLength = pinControls.reduce((acc, controlName) => {
        const control = formGroup.get(controlName);
        return acc + (control?.value?.length || 0);
      }, 0);

      // Ensure the total length is 6
      return pinLength === 6 ? null : { pinLength: true };
    };
  }
}
